// import React, { useState } from "react";
// import Scrollbars from "react-custom-scrollbars-2";
// import { Link, useLocation } from "react-router-dom";
// import * as Icon from "react-feather"; // Importing icons for use
// import HorizontalSidebar from "./horizontalSidebar";
// import CollapsedSidebar from "./collapsedSidebar";
// const Sidebar = () => {
//   const location = useLocation();
//   const [subOpen, setSubOpen] = useState("");
//   const storedUserData = localStorage.getItem("user");
//   const userData = JSON.parse(storedUserData);
//   const id = userData?.data?.uid; //
//   //console.log('user id1:', userData)
//   const [userRights, setUserRights] = useState([]);
//   useEffect(() => {
//     const fetchUserRights = async () => {
//       try {
//         const response = await fetch(`http://localhost:8000/api/userright/${id}`);
//         if (!response.ok) {
//           throw new Error("Failed to fetch user rights");
//         }
//         const data = await response.json();
//         console.log("Fetched Data:", data.data);
//         setUserRights(data.data || []); // Ensure it's always an array
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setUserRights([]); // Set to empty array in case of error
//       }
//     };
//     fetchUserRights(); // Fetch the data on component mount
//   }, [id]);
//   const toggleSidebar = (title) => {
//     setSubOpen(subOpen === title ? "" : title);
//   };
//
//   return (
//     <div>
//       <div className="sidebar" id="sidebar">
//         <Scrollbars>
//           <div className="sidebar-inner slimscroll">
//             <div id="sidebar-menu" className="sidebar-menu">
//             <ul>
//             {Array.isArray(userRights) && userRights.length > 0 ? (
//                   <>
//                     {userRights.map((right, index) => {
//                       if (right.right === "Dashboard" && right.status === 1) {
//                         // Rendering for "Dashboard" when status is 1
//                         return (
//
//                           <li key={index}
//                           className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px',
//
//                           }}
//                           >
//
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("Dashboard")}
//                               className={`${subOpen === "Dashboard" ? "subdrop" : ""} ${
//                                 location.pathname === "/" ? "" : "active"
//                               }`}
//                               style={{ backgroundColor: ' rgba(254, 159, 67, 0.08) '
//
//                               }}
//                             >
//                               <Icon.Grid />
//                               <span>Dashboard</span>
//                               <span
//                                 className={`menu-arrow ${subOpen === "Dashboard" ? "open" : ""}`}
//                               ></span>
//                             </Link>
//                             <ul
//                               style={{
//                                 display: subOpen === "Dashboard" ? "block" : "none",
//                               }}
//                             >
//                               <li>
//                                 <Link
//                                   to="/admin-dashboard"
//                                   className={`${
//                                     location.pathname === "/admin-dashboard" ? "active" : ""
//                                   }`}
//
//                                 >
//                                   Admin Dashboard
//                                 </Link>
//                               </li>
//                             </ul>
//
//                           </li>
//
//
//                         );
//
//                       }
//
//
//                       else if (right.right === "Jobs" && right.status === 1) {
//                         return (
//                           <li
//                           key={index}
//                           style={{
//                             marginBottom: '1px',  // Corrected 'marginbottom' to 'marginBottom'
//                           }}
//                         >
//
//                             <Link
//                               to="/jobs"
//
//                             >
//                               <Icon.Briefcase />
//                               <span>Job</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }  else if (right.right === "Services" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li
//                           key={index}
//                           style={{
//                             marginBottom: '1px',  // Corrected 'marginbottom' to 'marginBottom'
//                           }}
//                         >
//                             <Link
//                               to="/jobs-types"
//                               // onClick={() => toggleSidebar("Services")}
//                               // className={`${subOpen === "Services" ? "subdrop" : ""} ${
//                               //   location.pathname === "/jobs-types" ? "" : ""
//                               // }`}
//                             >
//                              <Icon.Copy/>
//                               <span>Services</span>
//                             </Link>
//                           </li>
//                         );
//                       }
//                        else if (right.right === "Body-Types" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index}
//                           style={{
//
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px'
//                           }}
//                           >
//                             <Link
//                               to="/body-types"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Type/>
//                               <span>Body Types</span>
//                             </Link>
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Inventory" && right.status === 1) {
//                         return (
//                           <li key={index} style={{ borderBottom: '1px solid #e8ebed', padding: '0 0 14px 0', display: 'block', marginBottom: '14px' }}>
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("Inventory")}
//                               className={`${subOpen === "Inventory" ? "subdrop" : ""} ${location.pathname === "/" ? "" : "active"}`}
//                             >
//                                <Icon.Package/>
//                               <span>Inventory</span>
//                               <span className={`menu-arrow ${subOpen === "Inventory" ? "open" : ""}`}></span>
//                             </Link>
//
//                             <ul
//                               style={{
//                                 display: subOpen === "Inventory" ? "block" : "none",
//                                 listStyleType: 'disc', // Adding dots to the list
//                                 paddingLeft: '35px' // Adjusting padding for dot spacing
//                               }}
//                             >
//                               {userRights.some(right => right.right === "product-list" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/product-list"
//                                     className={`${location.pathname === "/product-list" ? "active" : ""}`}
//                                   >
//                                     <span>Products</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "add-product" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/add-product"
//                                     className={`${location.pathname === "/add-product" ? "active" : ""}`}
//                                   >
//                                     <span>Create Product</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "services" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/jobs-types"
//                                     className={`${location.pathname === "/services" ? "active" : ""}`}
//                                   >
//                                     <span>Services</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "grn" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/grn"
//                                     className={`${location.pathname === "/grn" ? "active" : ""}`}
//                                   >
//                                     <span>GRN</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "issuance" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/issuance"
//                                     className={`${location.pathname === "/issuance" ? "active" : ""}`}
//                                   >
//                                     <span>Issuance</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "low-stocks" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/low-stocks"
//                                     className={`${location.pathname === "/low-stocks" ? "active" : ""}`}
//                                   >
//                                     <span>Low Stocks</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "category-list" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/category-list"
//                                     className={`${location.pathname === "/category-list" ? "active" : ""}`}
//                                   >
//                                     <span>Category</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "sub-categories" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/sub-categories"
//                                     className={`${location.pathname === "/sub-categories" ? "active" : ""}`}
//                                   >
//                                     <span>Sub Category</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "brand-list" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/brand-list"
//                                     className={`${location.pathname === "/brand-list" ? "active" : ""}`}
//                                   >
//                                     <span>Brands</span>
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "units" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/units"
//                                     className={`${location.pathname === "/units" ? "active" : ""}`}
//                                   >
//                                     <span>Units</span>
//                                   </Link>
//                                 </li>
//                               )}
//                             </ul>
//                           </li>
//                         );
//                       }
//
//
//                       else if (right.right === "Manage-Stock" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//
//                             marginBottom: "0px"
//                           }}
//                           >
//                             <Link
//                               to="/manage-stocks"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//
//
//                               // }`}
//                             >
//                               <Icon.Package/>
//                               <span>Manage Stock</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Stock-Adjustment" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}
//                           >
//                             <Link
//                               to="/stock-adjustment"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Clipboard/>
//                               <span>Stock Adjustment</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Stock-Transfer" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px'
//                           }}>
//                             <Link
//                               to="/stock-transfer"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Truck/>
//                               <span>Stock Transfer</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Invoices" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/invoices-list"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.FileText/>
//                               <span>Invoices</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       } else if (right.right === "Quotation" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px'
//                           }}>
//                             <Link
//                               to="/quotation-list"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Save/>
//                               <span>Quotation</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Coupons" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px'
//                           }}
//                           >
//                             <Link
//                               to="/coupons"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.ShoppingCart/>
//                               <span>Coupons</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Purchases" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/purchase-list"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.ShoppingBag/>
//                               <span>Purchases</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }  else if (right.right === "Purchase-Order" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/purchase-order-report"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.FileMinus/>
//                               <span>Purchase Order</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }  else if (right.right === "Purchase-Return" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                             style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px'
//                           }}
//                           >
//                             <Link
//                               to="/purchase-returns"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.RefreshCw/>
//                               <span>Purchase Return</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                        }
//                        if (right.right === "Expenses" && right.status === 1) {
//                         return (
//                           <li key={index} className="submenu" style={{ borderBottom: '1px solid #e8ebed', padding: '0 0 14px 0', display: 'block', marginBottom: '14px' }}>
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("Expenses")}
//                               className={`${subOpen === "Expenses" ? "subdrop" : ""} ${location.pathname === "/" ? "" : "active"}`}
//                             >
//                               <Icon.FileText />
//                               <span>Expenses</span>
//                               <span className={`menu-arrow ${subOpen === "Expenses" ? "open" : ""}`}></span>
//                             </Link>
//
//                             <ul style={{ display: subOpen === "Expenses" ? "block" : "none" }}>
//                               {/* Conditionally render each item based on right.right and right.status */}
//                               {userRights.some(right => right.right === "expense-list" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/expense-list"
//                                     className={`${location.pathname === "/expense-list" ? "active" : ""}`}
//                                   >
//                                     Expenses
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "expense-category" && right.status === 1) && (
//                                 <li>
//                                   <Link
//                                     to="/expense-category"
//                                     className={`${location.pathname === "/expense-category" ? "active" : ""}`}
//                                   >
//                                     Expense Category
//                                   </Link>
//                                 </li>
//                               )}
//                             </ul>
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "Customers" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}
//                           >
//                             <Link
//                               to="/customers"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.User/>
//                               <span>Customers</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Suppliers" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginbottom: '14px'
//                           }}>
//                             <Link
//                               to="/suppliers"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                              <Icon.Users/>
//                               <span>Suppliers</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "Employees" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/employees-grid"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Users/>
//                               <span>Employees</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Departments" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu" style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/department-grid"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.User/>
//                               <span>Departments</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Designations" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu" style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/designation"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.UserCheck/>
//                               <span>Designations</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Shifts" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu" style={{
//                             marginBottom: "0px"
//                           }}>
//                             <Link
//                               to="/shift"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Shuffle/>
//                               <span>Shifts</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "Attendance" && right.status === 1) {
//                         return (
//                           <li key={index} className="submenu" style={{ display: 'block', marginBottom: '0px' }}>
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("Attendance")}
//                               className={`${subOpen === "Attendance" ? "subdrop" : ""} ${location.pathname === "/" ? "" : "active"}`}
//                             >
//                               <Icon.Grid />
//                               <span>Attendance</span>
//                               <span className={`menu-arrow ${subOpen === "Attendance" ? "open" : ""}`}></span>
//                             </Link>
//
//                             <ul style={{ display: subOpen === "Attendance" ? "block" : "none" }}>
//                               {/* Conditionally render each item based on right.right and right.status */}
//                               {userRights.some(right => right.right === "attendance-employee" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/attendance-employee"
//                                     className={`${location.pathname === "/attendance-employee" ? "active" : ""}`}
//                                   >
//                                     Employee
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "attendance-admin" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/attendance-admin"
//                                     className={`${location.pathname === "/attendance-admin" ? "active" : ""}`}
//                                   >
//                                     Admin
//                                   </Link>
//                                 </li>
//                               )}
//                             </ul>
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "Leaves" && right.status === 1) {
//                         return (
//                           <li key={index} className="submenu" style={{ display: 'block', marginBottom: '0px' }}>
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("Leaves")}
//                               className={`${subOpen === "Leaves" ? "subdrop" : ""} ${location.pathname === "/" ? "" : "active"}`}
//                             >
//                               <Icon.Grid />
//                               <span>Leaves</span>
//                               <span className={`menu-arrow ${subOpen === "Leaves" ? "open" : ""}`}></span>
//                             </Link>
//
//                             <ul style={{ display: subOpen === "Leaves" ? "block" : "none" }}>
//                               {/* Conditionally render each item based on right.right and right.status */}
//                               {userRights.some(right => right.right === "leaves-employee" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/leaves-employee"
//                                     className={`${location.pathname === "/leaves-employee" ? "active" : ""}`}
//                                   >
//                                     Employee Leaves
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "leaves-admin" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/leaves-admin"
//                                     className={`${location.pathname === "/leaves-admin" ? "active" : ""}`}
//                                   >
//                                     Admin Leaves
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "leave-types" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/leave-types"
//                                     className={`${location.pathname === "/leave-types" ? "active" : ""}`}
//                                   >
//                                     Leave Types
//                                   </Link>
//                                 </li>
//                               )}
//                             </ul>
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "Holidays" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//
//                             <Link
//                               to="/holidays"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.Calendar/>
//                               <span>Holidays</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "payslip" && right.status === 1) {
//                         // Rendering for "Dashboard" when status is 1
//                         return (
//
//                           <li key={index}
//                           className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginBottom: '0px'
//                           }}
//                           >
//
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("Payroll")}
//                               className={`${subOpen === "Payroll" ? "subdrop" : ""} ${
//                                 location.pathname === "/" ? "" : "active"
//                               }`}
//                             >
//                               <Icon.DollarSign/>
//                               <span>Payroll</span>
//                               <span
//                                 className={`menu-arrow ${subOpen === "Payroll" ? "open" : ""}`}
//                               ></span>
//                             </Link>
//                             <ul
//                               style={{
//                                 display: subOpen === "Payroll" ? "block" : "none",
//                               }}
//                             >
//                               <li  style={{
//                             marginBottom: "0px"
//                           }}>
//                                 <Link
//                                   to="/payslip"
//                                   className={`${
//                                     location.pathname === "/payslip" ? "active" : ""
//                                   }`}
//                                 >
//                                 Payslip
//                                 </Link>
//                               </li>
//
//
//                             </ul>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Purchase-Report" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//
//                             <Link
//                               to="/purchase-report"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.PieChart/>
//                               <span>Purchase Report</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Inventory-Report" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//
//                             <Link
//                               to="/inventory-report"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                                <Icon.Inbox/>
//                               <span>Inventory Report</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Invoice-Report" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}>
//
//                             <Link
//                               to="/invoice-report"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                                <Icon.File/>
//                               <span>Invoice Report</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Profit-Loss" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginBottom: '0px'
//                           }}>
//
//                             <Link
//                               to="/profit-loss-report"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.TrendingDown/>
//                               <span>Profit & Loss</span>
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Users" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}
//                           >
//                             <Link
//                               to="/users"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.UserCheck/>
//                               <span>Users</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "Roles-Permissions" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}
//                           >
//                             <Link
//                               to="/roles-permissions"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.UserCheck/>
//                               <span>Roles & Permissions</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//                       else if (right.right === "user-Rights" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             marginBottom: "0px"
//                           }}
//                           >
//                             <Link
//                               to="/userrights"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                                <Icon.Lock />
//                               <span>user Rights</span>
//                             </Link>
//                           </li>
//                         );
//                       }
//                       else if (right.right === "Login-Out" && right.status === 1) {
//                         // Rendering for "Job" when status is 1
//                         return (
//                           <li key={index} className="submenu"
//                           style={{
//                             borderBottom: '1px solid #e8ebed',
//                             padding: '0 0 14px 0',
//                             display: 'block',
//                             marginBottom: '0px'
//                           }}
//                           >
//                             <Link
//                               to="/signin"
//                               // onClick={() => toggleSidebar("Job")}
//                               // className={`${subOpen === "Job" ? "subdrop" : ""} ${
//                               //   location.pathname === "/" ? "" : "active"
//                               // }`}
//                             >
//                               <Icon.LogOut />
//                               <span>Login-Out</span>
//
//                             </Link>
//
//                           </li>
//                         );
//                       }
//
//                       else if (right.right === "General-Setting" && right.status === 1) {
//                         return (
//                           <li
//                             key={index}
//                             className="submenu"
//                             style={{
//                               display: 'block',
//                               marginBottom: '0px',
//                             }}
//                           >
//                             <Link
//                               to="/"
//                               onClick={() => toggleSidebar("General-Setting")}
//                               className={`${subOpen === "General-Setting" ? "subdrop" : ""} ${
//                                 location.pathname === "/" ? "" : "active"
//                               }`}
//                             >
//                               <Icon.Grid />
//                               <span>General-Setting</span>
//                               <span
//                                 className={`menu-arrow ${subOpen === "General-Setting" ? "open" : ""}`}
//                               ></span>
//                             </Link>
//
//                             <ul
//                               style={{
//                                 display: subOpen === "General-Setting" ? "block" : "none",
//                               }}
//                             >
//                               {/* Rendering based on matching values for right */}
//                               {userRights.some(right => right.right === "Profile" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/general-settings1"
//                                     className={`${
//                                       location.pathname === "/general-settings1" ? "active" : ""
//                                     }`}
//                                   >
//                                     Profile
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "Security" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/security-settings"
//                                     className={`${
//                                       location.pathname === "/security-settings" ? "active" : ""
//                                     }`}
//                                   >
//                                     Security
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "Notifications" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/notification"
//                                     className={`${
//                                       location.pathname === "/notification" ? "active" : ""
//                                     }`}
//                                   >
//                                     Notifications
//                                   </Link>
//                                 </li>
//                               )}
//
//                               {userRights.some(right => right.right === "Connected Apps" && right.status === 1) && (
//                                 <li style={{ marginBottom: "0px" }}>
//                                   <Link
//                                     to="/connected-apps"
//                                     className={`${
//                                       location.pathname === "/connected-apps" ? "active" : ""
//                                     }`}
//                                   >
//                                     Connected Apps
//                                   </Link>
//                                 </li>
//                               )}
//                             </ul>
//                           </li>
//                         );
//                       }
//
//
//                       else {
//                         // If the `right` is neither "Dashboard" nor "Job" with status 1, render nothing
//                         return null;
//                       }
//                     })}
//                   </>
//                 ) : (
//                   <span>You do not have permission to access.plese contact admin</span>
//                 )}
//
//               </ul>
//             </div>
//           </div>
//         </Scrollbars>
//       </div>
//       <HorizontalSidebar />
//       <CollapsedSidebar />
//     </div>
//   );
// };
//
// export default Sidebar;

import React, { useContext, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { UserContext } from "../../context/userContext";
// import { hasPermission } from "../../core/json/permissions";

const Sidebar = () => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title) => {
    setSubopen(subOpen === title ? "" : title);
  };

  const toggleSubsidebar = (subitem) => {
    setSubsidebar(subsidebar === subitem ? "" : subitem);
  };

  if (!user || !user.permissions) {
    return <div>Loading...</div>;
  }

const hasModuleAccess = (moduleLabel) => {
  if (moduleLabel === "Settings") return true;
  const hasAccess = user.permissions.some(perm => {
    const matches = perm.label === moduleLabel || 
                   (perm.moduleId && perm.moduleId.label === moduleLabel);

    return matches;
  });

  return hasAccess;
};

  const hasFunctionAccess = (moduleLabel, functionLabel) => {
    if (moduleLabel === "Settings") return true;
    
    const module = user.permissions.find(perm => 
      perm.label === moduleLabel || 
      (perm.moduleId && perm.moduleId.label === moduleLabel)
    );
    
    if (!module) return false;
    
    return module.functions?.some(func => 
      func.label === functionLabel || 
      (func.functionId && func.functionId.label === functionLabel)
    );
  };

  const hasSubFunctionAccess = (moduleLabel, functionLabel, subFunctionLabel) => {
    if (moduleLabel === "Settings") return true;
    
    const module = user.permissions.find(perm => 
      perm.label === moduleLabel || 
      (perm.moduleId && perm.moduleId.label === moduleLabel)
    );
    
    if (!module) return false;
    
    const func = module.functions?.find(f => 
      f.label === functionLabel || 
      (f.functionId && f.functionId.label === functionLabel)
    );
    
    if (!func) return false;
    
    return func.subFunctions?.some(sub => 
      sub.label === subFunctionLabel || 
      (sub.functionId && sub.functionId.label === subFunctionLabel)
    );
  };

  /**
   * Checks permissions for sidebar items that opt-out of the "Settings" bypass
   * by setting requirePermission:true on the sidebar data item.
   *
   * DB structure:
   *   Module "Settings" → Function "Audit Logs" (direct, NOT a sub-function)
   *   user.permissions[].functions[].label === "Audit Logs"
   *   user.permissions[].functions[].permissions.view === true
   */
  const hasPermissionControlledAccess = (subItem) => {
    if (!subItem.requirePermission) return true;
    if (!user || !user.permissions) return false;

    const { permissionModule, permissionFunction } = subItem;
    const targetModule   = permissionModule ? permissionModule.trim().toLowerCase() : "";
    const targetFunction = permissionFunction ? permissionFunction.trim().toLowerCase() : "";

    for (const perm of user.permissions) {
      const modLabel = (perm.label || perm.moduleId?.label || "").trim().toLowerCase();
      if (targetModule && modLabel !== targetModule) continue;

      const functions = perm.functions || [];
      for (const func of functions) {
        const funcLabel = (func.label || func.functionId?.label || "").trim().toLowerCase();
        if (funcLabel === targetFunction) {
          return func.permissions?.view === true;
        }
      }
    }
    return false;
  };

  const buildMainMenuStructure = () => {
    return SidebarData.reduce((acc, module) => {
      if (!hasModuleAccess(module.label)) return acc;

      const moduleClone = { ...module, submenuItems: [] };

      if (module.submenuItems) {
        moduleClone.submenuItems = module.submenuItems.reduce((menuItems, menuItem) => {
          if (!hasFunctionAccess(module.label, menuItem.label)) return menuItems;

          const menuItemClone = { ...menuItem };

          if (menuItem.submenuItems) {
            menuItemClone.submenuItems = menuItem.submenuItems.filter(subItem =>
              hasPermissionControlledAccess(subItem) &&
              hasSubFunctionAccess(module.label, menuItem.label, subItem.label)
            );
          }

          if (!menuItem.submenuItems || menuItemClone.submenuItems.length > 0) {
            menuItems.push(menuItemClone);
          }

          return menuItems;
        }, []);
      }

      if (moduleClone.submenuItems.length > 0 || module.label === "Settings") {
        acc.push(moduleClone);
      }

      return acc;
    }, []);
  };

  const collectLinks = (item) => {
    const links = [];
    if (item.link) links.push(item.link);
    if (item.submenuItems) {
      item.submenuItems.forEach(subItem => {
        if (subItem.link) links.push(subItem.link);
        if (subItem.submenuItems) {
          subItem.submenuItems.forEach(nested => links.push(nested.link));
        }
      });
    }
    return links;
  };

  const filteredModules = buildMainMenuStructure();
  console.log("Filetered Modules",filteredModules)
  const currentPath = location.pathname;

  return (
    <div>
      <div className="sidebar" id="sidebar">
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredModules.map((module) => (
                  <li className="submenu-open" key={module.label}>
                    <h6 className="submenu-hdr">{module.label}</h6>
                    <ul>
                      {module.submenuItems?.map((menuItem) => {
                        const links = collectLinks(menuItem);
                        const isActive = links.includes(currentPath);
                        const hasSubmenu = menuItem.submenuItems?.length > 0;

                        return (
                          <li className="submenu" key={menuItem.label}>
                            <Link
                              to={menuItem.link || "#"}
                              onClick={() => toggleSidebar(menuItem.label)}
                              className={`${subOpen === menuItem.label ? "subdrop" : ""} ${
                                isActive ? "active" : ""
                              }`}
                            >
                              {menuItem.icon}
                              <span>{menuItem.label}</span>
                              {hasSubmenu && <span className="menu-arrow" />}
                            </Link>

                            {hasSubmenu && (
                              <ul style={{ display: subOpen === menuItem.label ? "block" : "none" }}>
                                {menuItem.submenuItems.map((subItem) => {
                                  const subLinks = collectLinks(subItem);
                                  const isSubActive = subLinks.includes(currentPath);
                                  const hasNestedSubmenu = subItem.submenuItems?.length > 0;

                                  return (
                                    <li className="submenu submenu-two" key={subItem.label}>
                                      <Link
                                        to={subItem.link || "#"}
                                        className={isSubActive ? "active" : ""}
                                        onClick={() => toggleSubsidebar(subItem.label)}
                                      >
                                        {subItem.label}
                                      </Link>

                                      {hasNestedSubmenu && (
                                        <ul style={{ display: subsidebar === subItem.label ? "block" : "none" }}>
                                          {subItem.submenuItems.map((nestedItem) => (
                                            <li key={nestedItem.label}>
                                              <Link
                                                to={nestedItem.link || "#"}
                                                className={`${
                                                  subsidebar === nestedItem.label ? "submenu-two subdrop" : "submenu-two"
                                                } ${
                                                  nestedItem.link === currentPath ? "active" : ""
                                                }`}
                                              >
                                                {nestedItem.label}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;